/**
 * bug_tracker_controller.js — dev/beta Bug Tracker modal chrome (Stimulus).
 *
 * Bound to #bugTrackerModal (data-controller="bug-tracker"), included by base.html
 * only when show_bug_tabs is true. Owns the modal CHROME only:
 *   - data-open-tab auto-selection (Report Bug vs View Bugs entry points), and
 *   - cancelEditBug() bridge on close.
 *
 * The bug-tracker behaviour itself (submitBug/filterBugs/loadBugs/editBug/…) stays
 * on the static/js/bug-tracker/* window.* globals via data-action="call-fn"; this
 * controller does not reimplement it. connect()/disconnect() re-bind on every Turbo
 * body swap, unlike a DOMContentLoaded handler that only fires on hard load.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        connect() {
            // shown.bs.modal (not show) so the tab transition doesn't fight the
            // fade-in. Drive the target tab via a real click so its
            // data-bs-toggle="tab" and (View Bugs) call-fn loadBugs both fire.
            this._onShown = (event) => {
                const trigger = event.relatedTarget;
                if (trigger && trigger.dataset.openTab) {
                    const targetTab = document.getElementById(trigger.dataset.openTab);
                    if (targetTab) targetTab.click();
                }
            };
            this.element.addEventListener('shown.bs.modal', this._onShown);

            this._onHidden = () => {
                if (typeof window.cancelEditBug === 'function' && window.bugTrackerState && window.bugTrackerState.editingBugId) {
                    window.cancelEditBug();
                }
            };
            this.element.addEventListener('hidden.bs.modal', this._onHidden);
        }

        disconnect() {
            if (this._onShown) this.element.removeEventListener('shown.bs.modal', this._onShown);
            if (this._onHidden) this.element.removeEventListener('hidden.bs.modal', this._onHidden);
        }
}
